import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("session_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (id) => (id ? `${API}/files/${id}` : "");

export function wsUrl() {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws`;
}
